<i
  class="fa sortable"
  [ngClass]="{ 'fa-caret-down': 'DESC' === order, 'fa-caret-up': 'ASC' === order }"
  (click)="onSort()"
  aria-hidden="true"
></i>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/sortable/sortable.component.html